import type { PoolRow } from "./api";

/** The two accounts release 1 reconciles, per entity (BN RB5, parent §7 S6). */
export const ACCOUNTS = [
  { code: "632", label: "Raw materials", poolField: "value" as const },
  { code: "627.4", label: "Inbound freight", poolField: "inbound_value" as const },
];

export const ESCALATE_ABOVE = 750;

export function poolTotal(rows: PoolRow[], field: "value" | "inbound_value"): string {
  return rows.reduce((sum, row) => sum + Number(row[field]), 0).toFixed(2);
}

export function delta(xeroTotal: string, poolSide: string): string {
  return (Number(xeroTotal) - Number(poolSide)).toFixed(2);
}

/** Same rule as rmvp.v_recon_check: ESCALATE above 750 absolute, REVIEW for any other non-zero, OK at zero. */
export function verdict(deltaValue: string): "OK" | "REVIEW" | "ESCALATE" {
  const difference = Math.abs(Number(deltaValue));
  if (difference > ESCALATE_ABOVE) return "ESCALATE";
  if (difference > 0) return "REVIEW";
  return "OK";
}
